import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

// Every draft action answers with its event (for the Undo bar) and the draft as it now stands; onView takes both.
export async function draftAct(v, method, path, body, onView) {
  try {
    const { data } = await api.request({ method, url: `/sales/draft/${v.kind}/${v.id}${path}`, data: body });
    onView(data);
    return data;
  } catch (e) {
    toast.error(formatApiErrorDetail(e.response?.data?.detail));
    return null;
  }
}
